import React, { Component } from 'react';
import api from '../../store/api/api';
import { fetchAddressSuggestions as fetchUberAddressSuggestions } from '../uber/fetchAddressSuggestions';

export default class UberSiteCrewModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pickupSuggestions: [],
      dropoffSuggestions: [],
      stopSuggestions: {},
      showPickupAutocomplete: false,
      showDropoffAutocomplete: false,
      showStopAutocomplete: {},
      pickupAccessPoints: [],
      dropoffAccessPoints: [],
      stopAccessPoints: {},
      loadingPickupAccessPoints: false,
      loadingDropoffAccessPoints: false,
      loadingStopAccessPoints: {},
    };
    this.pickupAutocompleteTimeout = null;
    this.dropoffAutocompleteTimeout = null;
    this.stopAutocompleteTimeouts = {};
    this.pickupAutocompleteRef = null;
    this.dropoffAutocompleteRef = null;
    this.stopAutocompleteRefs = {};
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    if (this.pickupAutocompleteTimeout) clearTimeout(this.pickupAutocompleteTimeout);
    if (this.dropoffAutocompleteTimeout) clearTimeout(this.dropoffAutocompleteTimeout);
    Object.values(this.stopAutocompleteTimeouts).forEach(timeout => {
      if (timeout) clearTimeout(timeout);
    });
  }

  handleClickOutside = (event) => {
    if (this.pickupAutocompleteRef && !this.pickupAutocompleteRef.contains(event.target)) {
      this.setState({ showPickupAutocomplete: false });
    }
    if (this.dropoffAutocompleteRef && !this.dropoffAutocompleteRef.contains(event.target)) {
      this.setState({ showDropoffAutocomplete: false });
    }
    Object.entries(this.stopAutocompleteRefs).forEach(([index, ref]) => {
      if (ref && !ref.contains(event.target)) {
        this.setState(prevState => ({
          showStopAutocomplete: {
            ...prevState.showStopAutocomplete,
            [index]: false
          }
        }));
      }
    });
  }

  updateRide = (changes) => {
    const { uberRide, onUpdate } = this.props;
    onUpdate({ ...uberRide, ...changes });
  };

  handlePickupAddressChange = (value) => {
    this.updateRide({
      pickupCustomAddress: value,
      pickupAddressObject: null,
      pickupAccessPoint: null
    });
    this.setState({ pickupAccessPoints: [], loadingPickupAccessPoints: false });

    if (this.pickupAutocompleteTimeout) {
      clearTimeout(this.pickupAutocompleteTimeout);
    }

    if (value.length < 3) {
      this.setState({ pickupSuggestions: [], showPickupAutocomplete: false });
      return;
    }

    this.pickupAutocompleteTimeout = setTimeout(() => {
      this.fetchAddressSuggestions(value, 'pickup');
    }, 300);
  }

  handleDropoffAddressChange = (value) => {
    this.updateRide({
      dropoffCustomAddress: value,
      dropoffAddressObject: null,
      dropoffAccessPoint: null
    });
    this.setState({ dropoffAccessPoints: [], loadingDropoffAccessPoints: false });

    if (this.dropoffAutocompleteTimeout) {
      clearTimeout(this.dropoffAutocompleteTimeout);
    }

    if (value.length < 3) {
      this.setState({ dropoffSuggestions: [], showDropoffAutocomplete: false });
      return;
    }

    this.dropoffAutocompleteTimeout = setTimeout(() => {
      this.fetchAddressSuggestions(value, 'dropoff');
    }, 300);
  }

  handleStopAddressChange = (stopIndex, value) => {
    const newStops = [...this.props.uberRide.stops];
    newStops[stopIndex].customAddress = value;
    newStops[stopIndex].accessPoint = null;
    this.updateRide({ stops: newStops });

    this.setState(prevState => ({
      stopAccessPoints: {
        ...prevState.stopAccessPoints,
        [stopIndex]: []
      },
      loadingStopAccessPoints: {
        ...prevState.loadingStopAccessPoints,
        [stopIndex]: false
      }
    }));

    if (this.stopAutocompleteTimeouts[stopIndex]) {
      clearTimeout(this.stopAutocompleteTimeouts[stopIndex]);
    }

    if (value.length < 3) {
      this.setState(prevState => ({
        stopSuggestions: {
          ...prevState.stopSuggestions,
          [stopIndex]: []
        },
        showStopAutocomplete: {
          ...prevState.showStopAutocomplete,
          [stopIndex]: false
        }
      }));
      return;
    }

    this.stopAutocompleteTimeouts[stopIndex] = setTimeout(() => {
      this.fetchAddressSuggestions(value, 'stop', stopIndex);
    }, 300);
  }

  fetchAddressSuggestions = async (query, type, stopIndex = null) => {
    try {
      const suggestions = await fetchUberAddressSuggestions(query);

      if (type === 'pickup') {
        this.setState({
          pickupSuggestions: suggestions,
          showPickupAutocomplete: true
        });
      } else if (type === 'dropoff') {
        this.setState({
          dropoffSuggestions: suggestions,
          showDropoffAutocomplete: true
        });
      } else if (type === 'stop' && stopIndex !== null) {
        this.setState(prevState => ({
          stopSuggestions: {
            ...prevState.stopSuggestions,
            [stopIndex]: suggestions
          },
          showStopAutocomplete: {
            ...prevState.showStopAutocomplete,
            [stopIndex]: true
          }
        }));
      }
    } catch (error) {
      console.error('Error fetching address suggestions:', error);
    }
  }

  fetchRequestZones = async (latitude, longitude, type, stopIndex = null) => {
    try {
      if (type === 'pickup') {
        this.setState({ loadingPickupAccessPoints: true });
      } else if (type === 'dropoff') {
        this.setState({ loadingDropoffAccessPoints: true });
      } else if (type === 'stop' && stopIndex !== null) {
        this.setState(prevState => ({
          loadingStopAccessPoints: {
            ...prevState.loadingStopAccessPoints,
            [stopIndex]: true
          }
        }));
      }

      // when ready - we'll flip this out for get-closest-request-zone
      const response = await api.get(`/uber/get-request-zones?latitude=${latitude}&longitude=${longitude}`);
      const data = response.data;
      const accessPoints = this.parseAccessPoints(data);

      // const response = await api.get(`/uber/get-closest-access-point?latitude=${latitude}&longitude=${longitude}`);
      // const data = response.data;
      // const accessPoints = [];
      // accessPoints.push(data)

      if (type === 'pickup') {
        this.setState({
          pickupAccessPoints: accessPoints,
          loadingPickupAccessPoints: false
        });
        if (accessPoints.length > 0) {
          this.updateRide({ pickupAccessPoint: accessPoints[0] });
        }
      } else if (type === 'dropoff') {
        this.setState({
          dropoffAccessPoints: accessPoints,
          loadingDropoffAccessPoints: false
        });
        if (accessPoints.length > 0) {
          this.updateRide({ dropoffAccessPoint: accessPoints[0] });
        }
      } else if (type === 'stop' && stopIndex !== null) {
        this.setState(prevState => ({
          stopAccessPoints: {
            ...prevState.stopAccessPoints,
            [stopIndex]: accessPoints
          },
          loadingStopAccessPoints: {
            ...prevState.loadingStopAccessPoints,
            [stopIndex]: false
          }
        }));
        if (accessPoints.length > 0) {
          const newStops = [...this.props.uberRide.stops];
          newStops[stopIndex].accessPoint = accessPoints[0];
          this.updateRide({ stops: newStops });
        }
      }
    } catch (error) {
      console.error('Error fetching request zones:', error);
      if (type === 'pickup') {
        this.setState({ loadingPickupAccessPoints: false });
      } else if (type === 'dropoff') {
        this.setState({ loadingDropoffAccessPoints: false });
      } else if (type === 'stop' && stopIndex !== null) {
        this.setState(prevState => ({
          loadingStopAccessPoints: {
            ...prevState.loadingStopAccessPoints,
            [stopIndex]: false
          }
        }));
      }
    }
  }

  parseAccessPoints = (data) => {
    if (data.access_points && Array.isArray(data.access_points)) {
      return data.access_points.map(ap => ({
        id: ap.id,
        label: ap.label,
        latitude: ap.latitude,
        longitude: ap.longitude,
        rider_wayfinding_note: ap.rider_wayfinding_note
      }));
    }

    if (data.master_zone) {
      if (data.master_zone.sub_zones && Array.isArray(data.master_zone.sub_zones)) {
        const accessPoints = [];
        data.master_zone.sub_zones.forEach(subZone => {
          if (subZone.access_points && Array.isArray(subZone.access_points)) {
            subZone.access_points.forEach(ap => {
              accessPoints.push({
                id: ap.id,
                label: `${subZone.name} - ${ap.label}`,
                latitude: ap.latitude,
                longitude: ap.longitude,
                rider_wayfinding_note: ap.rider_wayfinding_note
              });
            });
          }
        });
        return accessPoints;
      } else if (data.master_zone.access_points && Array.isArray(data.master_zone.access_points)) {
        return data.master_zone.access_points.map(ap => ({
          id: ap.id,
          label: ap.label,
          latitude: ap.latitude,
          longitude: ap.longitude,
          rider_wayfinding_note: ap.rider_wayfinding_note
        }));
      }
    }

    return [];
  }

  selectPickupAddress = (suggestion) => {
    const displayValue = suggestion.name || suggestion.full_address;
    this.updateRide({
      pickupCustomAddress: displayValue,
      pickupAddressData: suggestion
    });
    this.setState({
      pickupSuggestions: [],
      showPickupAutocomplete: false
    });

    if (suggestion.latitude && suggestion.longitude) {
      this.fetchRequestZones(suggestion.latitude, suggestion.longitude, 'pickup');
    }
  }

  selectDropoffAddress = (suggestion) => {
    const displayValue = suggestion.name || suggestion.full_address;
    this.updateRide({
      dropoffCustomAddress: displayValue,
      dropoffAddressData: suggestion
    });
    this.setState({
      dropoffSuggestions: [],
      showDropoffAutocomplete: false
    });

    if (suggestion.latitude && suggestion.longitude) {
      this.fetchRequestZones(suggestion.latitude, suggestion.longitude, 'dropoff');
    }
  }

  selectStopAddress = (stopIndex, suggestion) => {
    const displayValue = suggestion.name || suggestion.full_address;
    const newStops = [...this.props.uberRide.stops];
    newStops[stopIndex].customAddress = displayValue;
    newStops[stopIndex].customAddressData = suggestion;
    this.updateRide({ stops: newStops });
    this.setState(prevState => ({
      stopSuggestions: {
        ...prevState.stopSuggestions,
        [stopIndex]: []
      },
      showStopAutocomplete: {
        ...prevState.showStopAutocomplete,
        [stopIndex]: false
      }
    }));

    if (suggestion.latitude && suggestion.longitude) {
      this.fetchRequestZones(suggestion.latitude, suggestion.longitude, 'stop', stopIndex);
    }
  }

  renderDropdown(groupedOptions, value, onChange, placeholder) {
    return (
        <select className="input" value={value || ''} onChange={onChange}>
          <option value="">{placeholder}</option>
          {groupedOptions.map((opt, idx) => {
            if (opt.isLabel) {
              return <optgroup key={idx} label={opt.label} />;
            }
            return (
                <option key={idx} value={opt.value} disabled={opt.disabled}>
                  {opt.display}
                </option>
            );
          })}
        </select>
    );
  }

  renderAutocompleteDropdown(suggestions, onSelect) {
    if (!suggestions || suggestions.length === 0) return null;

    return (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          backgroundColor: 'white',
          border: '1px solid #ccc',
          borderRadius: '4px',
          maxHeight: '200px',
          overflowY: 'auto',
          zIndex: 10000,
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          marginTop: '4px'
        }}>
          {suggestions.map((suggestion, index) => {
            const primaryDisplay = suggestion.name || suggestion.full_address;
            const secondaryDisplay = suggestion.name ? suggestion.address_line_2 : null;

            return (
                <div
                    key={index}
                    style={{
                      padding: '12px 14px',
                      cursor: 'pointer',
                      borderBottom: index < suggestions.length - 1 ? '1px solid #eee' : 'none',
                      transition: 'background-color 0.15s'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                    onClick={() => onSelect(suggestion)}
                >
                  <div style={{ fontWeight: '500', marginBottom: secondaryDisplay ? '3px' : '0', color: '#333' }}>
                    {primaryDisplay}
                  </div>
                  {secondaryDisplay && (
                      <div style={{ fontSize: '12px', color: '#666' }}>
                        {secondaryDisplay}
                      </div>
                  )}
                </div>
            );
          })}
        </div>
    );
  }

  renderAccessPointDropdown(accessPoints, selectedAccessPoint, onChange, isLoading) {
    if (isLoading) {
      return (
          <div style={{ marginTop: '10px', minHeight: '42px' }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '10px',
              backgroundColor: '#f9f9f9',
              borderRadius: '4px',
              border: '1px solid #e0e0e0'
            }}>
              <i className="fa fa-spinner fa-spin" style={{ marginRight: '8px', color: '#9b59b6' }}></i>
              <span style={{ fontSize: '13px', color: '#666' }}>Loading refinement options...</span>
            </div>
          </div>
      );
    }

    if (!accessPoints || accessPoints.length === 0 || accessPoints.length === 1) {
      return null;
    }

    const selectedValue = selectedAccessPoint ? JSON.stringify(selectedAccessPoint) : '';

    return (
        <div style={{ marginTop: '10px' }}>
          <select
              className="input"
              value={selectedValue}
              onChange={(e) => {
                const selected = e.target.value ? JSON.parse(e.target.value) : null;
                onChange(selected);
              }}
              style={{ fontSize: '14px' }}
          >
            {accessPoints.map((ap, idx) => (
                <option key={idx} value={JSON.stringify(ap)}>
                  {ap.label}
                </option>
            ))}
          </select>
        </div>
    );
  }

  buildGroupedOptions() {
    const { uberRide, routeseats, office } = this.props;
    const groupedOptions = [];
    groupedOptions.push({ isLabel: true, label: '-- Office --' });
    groupedOptions.push({
      type: 'office',
      display: 'Office',
      value: JSON.stringify({
        type: 'office',
        office_id: office || null,
      }),
    });

    const allSeatNums = routeseats.map((_, i) => i + 1);

    // seats sharing the exact same other_seat_address entry (door crews only --
    // each seat's own already-assigned dropoff and/or ending-pickup, see
    // DoorCrewCard's pseudoRouteseats) fold into one combined option
    // ("Seat 1 & 2 & 3: <address> (Dropoff)") instead of a separate "-- Seat N --"
    // header + option per seat. A seat can contribute more than one address now
    // (dropoff and ending pickup), so grouping is scoped by 'kind' as well as
    // location -- a seat's dropoff never merges with another seat's (or its own)
    // ending pickup, even at identical coordinates. Keyed by kind+lat/lon (falling
    // back to kind+display text) so the same physical point groups together
    // regardless of minor label differences.
    const addressKey = (address) => {
      const locationPart =
        address.latitude != null && address.longitude != null
          ? `${address.latitude},${address.longitude}`
          : address.address_display;
      return `${address.kind || ''}:${locationPart}`;
    };

    const seatsByAddressKey = new Map();
    allSeatNums.forEach((seatNum) => {
      (routeseats[seatNum - 1]?.other_seat_address || []).forEach((address) => {
        const key = addressKey(address);
        if (!key) return;

        if (!seatsByAddressKey.has(key)) {
          seatsByAddressKey.set(key, { seatNums: [], address });
        }
        seatsByAddressKey.get(key).seatNums.push(seatNum);
      });
    });

    const joinSeatNums = (seatNums) =>
      seatNums.length === 1
        ? `Seat ${seatNums[0]}`
        : `Seat ${seatNums.slice(0, -1).join(', ')} & ${seatNums[seatNums.length - 1]}`;

    const labelSuffix = (address) => (address.label ? ` (${address.label})` : '');

    // tracks address-key groups already emitted, so a seat grouped with a later
    // seat doesn't get re-rendered when that later seat is visited
    const renderedGroupKeys = new Set();

    // a merged group's first option (Seat 1 & 2: ...) doesn't get its own
    // "-- Seat N --" header, since it isn't any one seat -- without this, a
    // dropdown that opens with a merged group would show it directly under
    // "-- Office --" with nothing marking the start of the seats section
    if (allSeatNums.length) {
      groupedOptions.push({ isLabel: true, label: '-- Seats --' });
    }

    allSeatNums.forEach((seatNum) => {
      const seatObj = routeseats[seatNum - 1];
      const addresses = seatObj?.other_seat_address || [];

      if (addresses.length) {
        // lazily written right before this seat's first ungrouped option --
        // options merged into an earlier seat's group don't get a header at all
        let wroteHeader = false;

        addresses.forEach((address) => {
          const key = addressKey(address);
          if (renderedGroupKeys.has(key)) return;
          renderedGroupKeys.add(key);

          const group = seatsByAddressKey.get(key);

          if (group.seatNums.length > 1) {
            groupedOptions.push({
              type: 'other_address',
              seat: group.seatNums[0],
              seats: group.seatNums,
              site_id: '',
              display: `${joinSeatNums(group.seatNums)}: ${address.address_display}${labelSuffix(address)}`,
              value: JSON.stringify({
                type: 'other_address',
                seat: group.seatNums[0],
                seats: group.seatNums,
                latitude: address.latitude,
                longitude: address.longitude,
                address: address.address_display,
              }),
            });
          } else {
            if (!wroteHeader) {
              groupedOptions.push({ isLabel: true, label: `-- Seat ${seatNum} --` });
              wroteHeader = true;
            }
            groupedOptions.push({
              type: 'other_address',
              seat: seatNum,
              site_id: '',
              display: `${address.address_display}${labelSuffix(address)}`,
              value: JSON.stringify({
                type: 'other_address',
                seat: seatNum,
                latitude: address.latitude,
                longitude: address.longitude,
                address: address.address_display,
              }),
            });
          }
        });
        return;
      }

      groupedOptions.push({ isLabel: true, label: `-- Seat ${seatNum} --` });

      if (seatObj && Array.isArray(seatObj.sites) && seatObj.sites.length) {
        seatObj.sites.forEach((site, idx) => {
          groupedOptions.push({
            type: 'site',
            seat: seatNum,
            site_id: site.site_id,
            display: `${seatNum}.${idx + 1}: ${site.site_name}${
                site.addressline1 ? ' – ' + site.addressline1 : ''
            }`,
            value: JSON.stringify({
              type: 'site',
              seat: seatNum,
              site_id: site.site_id,
            }),
          });
        });
      } else {
        groupedOptions.push({
          type: 'empty',
          disabled: true,
          value: '',
          display: '(No sites assigned)',
        });
      }
    });

    groupedOptions.push({ isLabel: true, label: '-- Other --' });
    groupedOptions.push({
      type: 'address',
      display: 'Custom Address…',
      value: JSON.stringify({
        type: 'address',
        custom_address: '',
      }),
    });

    return groupedOptions;
  }

  renderLocationSection(type, index = null) {
    const { uberRide } = this.props;
    const groupedOptions = this.buildGroupedOptions();

    let locationType, customAddress, accessPoint, accessPoints, isLoading;
    let icon, label, placeholder, stepNumber;

    if (type === 'pickup') {
      locationType = uberRide.pickupLocationType;
      customAddress = uberRide.pickupCustomAddress;
      accessPoint = uberRide.pickupAccessPoint;
      accessPoints = this.state.pickupAccessPoints;
      isLoading = this.state.loadingPickupAccessPoints;
      icon = 'fa-circle';
      label = 'Pickup Location';
      placeholder = 'Select pickup location';
      stepNumber = 3;
    } else if (type === 'dropoff') {
      locationType = uberRide.dropoffLocationType;
      customAddress = uberRide.dropoffCustomAddress;
      accessPoint = uberRide.dropoffAccessPoint;
      accessPoints = this.state.dropoffAccessPoints;
      isLoading = this.state.loadingDropoffAccessPoints;
      icon = 'fa-map-marker-alt';
      label = 'Dropoff Location';
      placeholder = 'Select dropoff location';
      stepNumber = 4;
    } else if (type === 'stop') {
      const stop = uberRide.stops[index];
      locationType = stop.locationType;
      customAddress = stop.customAddress;
      accessPoint = stop.accessPoint;
      accessPoints = this.state.stopAccessPoints[index] || [];
      isLoading = this.state.loadingStopAccessPoints[index] || false;
      icon = 'fa-circle';
      label = `Stop #${index + 1}`;
      placeholder = 'Select stop location';
    }

    const locationObj = locationType ? JSON.parse(locationType) : null;
    const isCustom = locationObj?.type === 'address';

    return (
        <div style={{
          backgroundColor: '#fff',
          border: '2px solid #e0e0e0',
          borderRadius: '8px',
          padding: '16px',
          marginBottom: '12px',
          position: 'relative'
        }}>
          {type !== 'stop' && (
              <div style={{
                position: 'absolute',
                top: '-12px',
                left: '16px',
                backgroundColor: '#fff',
                padding: '0 8px',
                fontWeight: '600',
                fontSize: '13px',
                color: '#606c76'
              }}>
                STEP {stepNumber}
              </div>
          )}

          {type === 'stop' && (
              <div
                  onClick={() => {
                    const newStops = uberRide.stops.filter((_, i) => i !== index);
                    this.updateRide({ stops: newStops });
                    delete this.stopAutocompleteRefs[index];
                    if (this.stopAutocompleteTimeouts[index]) {
                      clearTimeout(this.stopAutocompleteTimeouts[index]);
                      delete this.stopAutocompleteTimeouts[index];
                    }
                  }}
                  style={{
                    position: 'absolute',
                    top: '8px',
                    right: '8px',
                    width: '32px',
                    height: '32px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    borderRadius: '4px',
                    transition: 'background-color 0.15s'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
              >
                <i className="far fa-times-circle" style={{ fontSize: '18px', color: '#999' }} />
              </div>
          )}

          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
            <div style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              backgroundColor: type === 'pickup' ? '#4CAF50' : type === 'dropoff' ? '#2196F3' : '#FF9800',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '12px',
              flexShrink: 0
            }}>
              <i className={`fas ${icon}`} style={{ color: 'white', fontSize: '14px' }} />
            </div>
            <label className="meta-label" style={{ margin: 0, fontSize: '15px', fontWeight: '600' }}>
              {label}
            </label>
          </div>

          {type === 'pickup' && this.renderDropdown(
              groupedOptions,
              locationType,
              (e) => {
                this.updateRide({
                  pickupLocationType: e.target.value,
                  pickupAccessPoint: null
                });
                this.setState({
                  pickupAccessPoints: [],
                  loadingPickupAccessPoints: false
                });
              },
              placeholder
          )}

          {type === 'dropoff' && this.renderDropdown(
              groupedOptions,
              locationType,
              (e) => {
                this.updateRide({
                  dropoffLocationType: e.target.value,
                  dropoffAccessPoint: null
                });
                this.setState({
                  dropoffAccessPoints: [],
                  loadingDropoffAccessPoints: false
                });
              },
              placeholder
          )}

          {type === 'stop' && this.renderDropdown(
              groupedOptions,
              locationType,
              (e) => {
                const newStops = [...uberRide.stops];
                newStops[index].locationType = e.target.value;
                newStops[index].accessPoint = null;
                const parsed = e.target.value ? JSON.parse(e.target.value) : null;
                if (!parsed || parsed.type !== 'address') {
                  newStops[index].customAddress = '';
                }
                this.updateRide({ stops: newStops });
                this.setState(prevState => ({
                  stopAccessPoints: {
                    ...prevState.stopAccessPoints,
                    [index]: []
                  },
                  loadingStopAccessPoints: {
                    ...prevState.loadingStopAccessPoints,
                    [index]: false
                  }
                }));
              },
              placeholder
          )}

          {isCustom && (
              <div>
                <div
                    ref={(el) => {
                      if (type === 'pickup') this.pickupAutocompleteRef = el;
                      else if (type === 'dropoff') this.dropoffAutocompleteRef = el;
                      else if (type === 'stop') this.stopAutocompleteRefs[index] = el;
                    }}
                    style={{ position: 'relative', marginTop: '10px' }}
                >
                  <input
                      type="text"
                      className="input"
                      placeholder={`Enter ${type === 'pickup' ? 'pickup' : type === 'dropoff' ? 'dropoff' : 'stop'} address`}
                      value={customAddress || ''}
                      onChange={(e) => {
                        if (type === 'pickup') this.handlePickupAddressChange(e.target.value);
                        else if (type === 'dropoff') this.handleDropoffAddressChange(e.target.value);
                        else if (type === 'stop') this.handleStopAddressChange(index, e.target.value);
                      }}
                      style={{
                        paddingLeft: '40px',
                        fontSize: '14px'
                      }}
                  />
                  <i className="fas fa-search" style={{
                    position: 'absolute',
                    left: '14px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: '#999',
                    fontSize: '14px'
                  }} />

                  {type === 'pickup' && this.state.showPickupAutocomplete &&
                      this.renderAutocompleteDropdown(this.state.pickupSuggestions, this.selectPickupAddress)}

                  {type === 'dropoff' && this.state.showDropoffAutocomplete &&
                      this.renderAutocompleteDropdown(this.state.dropoffSuggestions, this.selectDropoffAddress)}

                  {type === 'stop' && this.state.showStopAutocomplete[index] && this.state.stopSuggestions[index] &&
                      this.renderAutocompleteDropdown(
                          this.state.stopSuggestions[index],
                          (suggestion) => this.selectStopAddress(index, suggestion)
                      )}
                </div>

                {type === 'pickup' && this.renderAccessPointDropdown(
                    accessPoints,
                    accessPoint,
                    (ap) => this.updateRide({ pickupAccessPoint: ap }),
                    isLoading
                )}

                {type === 'dropoff' && this.renderAccessPointDropdown(
                    accessPoints,
                    accessPoint,
                    (ap) => this.updateRide({ dropoffAccessPoint: ap }),
                    isLoading
                )}

                {type === 'stop' && this.renderAccessPointDropdown(
                    accessPoints,
                    accessPoint,
                    (ap) => {
                      const newStops = [...uberRide.stops];
                      newStops[index].accessPoint = ap;
                      this.updateRide({ stops: newStops });
                    },
                    isLoading
                )}
              </div>
          )}
        </div>
    );
  }

  getRiderName(seatNum) {
    const { routeseats, canvassers } = this.props;
    const seatObj = routeseats ? routeseats[seatNum - 1] : null;
    if (!seatObj || !seatObj.canvasser_id) return null;
    const canvasser = (canvassers || []).find(c => c.id === seatObj.canvasser_id);
    if (!canvasser) return null;
    return `${canvasser.firstname} ${canvasser.lastname}`;
  }

  render() {
    const { show, uberRide, seatCount, onClose, onSave, saving } = this.props;
    if (!show) return null;

    const seatNumbers = Array.from({ length: seatCount }, (_, i) => i + 1);

    const pickupObj = uberRide.pickupLocationType ? JSON.parse(uberRide.pickupLocationType) : null;
    const dropoffObj = uberRide.dropoffLocationType ? JSON.parse(uberRide.dropoffLocationType) : null;
    const isPickupCustom = pickupObj?.type === 'address';
    const isDropoffCustom = dropoffObj?.type === 'address';

    const stopsValid = (uberRide.stops || []).every((stop) => {
      if (!stop.locationType) return false;
      const obj = JSON.parse(stop.locationType);
      if (obj.type !== 'address') return true;
      return (stop.customAddress || '').trim() !== '';
    });

    const isValid =
        (uberRide.scheduleType === 'flexible' || uberRide.scheduleType === 'ondemand' || uberRide.pickupTime) &&
        uberRide.primaryRider &&
        uberRide.pickupLocationType &&
        uberRide.dropoffLocationType &&
        (!isPickupCustom || (uberRide.pickupCustomAddress || '').trim() !== '') &&
        (!isDropoffCustom || (uberRide.dropoffCustomAddress || '').trim() !== '') &&
        stopsValid;

    return (
        <div
            className="modal-overlay"
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              background: 'rgba(0,0,0,0.5)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 9999,
            }}
        >
          <div
              className="uber-modal-card"
              style={{
                width: '600px',
                maxWidth: '90vw',
                background: '#fff',
                borderRadius: '12px',
                boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                maxHeight: '85vh',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
              }}
          >
            <div style={{
              padding: '24px 24px 16px',
              borderBottom: '1px solid #e0e0e0',
              backgroundColor: '#fafafa'
            }}>
              <h3 style={{ margin: 0, fontSize: '22px', fontWeight: '600', color: '#333' }}>
                Schedule Uber Ride
              </h3>
              <p style={{ margin: '8px 0 0', fontSize: '14px', color: '#666' }}>
                Configure ride details and route
              </p>
            </div>

            <div
                className="uber-modal-scroll"
                style={{
                  padding: '24px',
                  overflowY: 'auto',
                  flex: 1,
                  backgroundColor: '#f9f9f9'
                }}
            >
              <div style={{
                backgroundColor: '#fff',
                border: '2px solid #e0e0e0',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '20px',
                position: 'relative'
              }}>
                <div style={{
                  position: 'absolute',
                  top: '-12px',
                  left: '16px',
                  backgroundColor: '#fff',
                  padding: '0 8px',
                  fontWeight: '600',
                  fontSize: '13px',
                  color: '#606c76'
                }}>
                  STEP 1
                </div>

                <label className="meta-label" style={{ fontSize: '15px', fontWeight: '600', marginBottom: '12px' }}>
                  Schedule Type
                </label>
                <div className="uber-radio-options" style={{ display: 'flex', gap: '12px', marginBottom: '16px' }}>
                  <label className="uber-radio-option" style={{
                    flex: 1,
                    padding: '12px',
                    border: '2px solid',
                    borderColor: uberRide.scheduleType === 'ondemand' ? '#9b59b6' : '#ddd',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                    backgroundColor: uberRide.scheduleType === 'ondemand' ? '#f3e5f5' : 'white'
                  }}>
                    <input
                        type="radio"
                        name="schedtype"
                        checked={uberRide.scheduleType === 'ondemand'}
                        onChange={() => this.updateRide({ scheduleType: 'ondemand' })}
                        style={{ marginRight: '8px' }}
                    />
                    <span style={{ fontWeight: '500' }}>On Demand</span>
                  </label>

                  <label className="uber-radio-option" style={{
                    flex: 1,
                    padding: '12px',
                    border: '2px solid',
                    borderColor: uberRide.scheduleType === 'flexible' ? '#9b59b6' : '#ddd',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                    backgroundColor: uberRide.scheduleType === 'flexible' ? '#f3e5f5' : 'white'
                  }}>
                    <input
                        type="radio"
                        name="schedtype"
                        checked={uberRide.scheduleType === 'flexible'}
                        onChange={() => this.updateRide({ scheduleType: 'flexible' })}
                        style={{ marginRight: '8px' }}
                    />
                    <span style={{ fontWeight: '500' }}>Flexible</span>
                  </label>

                  <label className="uber-radio-option" style={{
                    flex: 1,
                    padding: '12px',
                    border: '2px solid',
                    borderColor: uberRide.scheduleType === 'scheduled' ? '#9b59b6' : '#ddd',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                    backgroundColor: uberRide.scheduleType === 'scheduled' ? '#f3e5f5' : 'white'
                  }}>
                    <input
                        type="radio"
                        name="schedtype"
                        checked={uberRide.scheduleType === 'scheduled'}
                        onChange={() => {
                            const d = new Date();
                            const today = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
                            this.updateRide({ scheduleType: 'scheduled', pickup_date: today });
                        }}
                        style={{ marginRight: '8px' }}
                    />
                    <span style={{ fontWeight: '500' }}>Scheduled</span>
                  </label>
                </div>

                {uberRide.scheduleType === 'scheduled' && (
                    <div>
                      <label className="meta-label" style={{ fontSize: '14px' }}>Pickup Time</label>
                      <input
                          type="time"
                          step="900"
                          className="input"
                          value={uberRide.pickupTime || ''}
                          onChange={(e) => this.updateRide({ pickupTime: e.target.value })}
                          style={{ fontSize: '14px' }}
                      />
                    </div>
                )}
              </div>

              <div style={{
                backgroundColor: '#fff',
                border: '2px solid #e0e0e0',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '20px',
                position: 'relative'
              }}>
                <div style={{
                  position: 'absolute',
                  top: '-12px',
                  left: '16px',
                  backgroundColor: '#fff',
                  padding: '0 8px',
                  fontWeight: '600',
                  fontSize: '13px',
                  color: '#606c76'
                }}>
                  STEP 2
                </div>

                <label className="meta-label" style={{ fontSize: '15px', fontWeight: '600', marginBottom: '12px' }}>
                  Primary Rider
                </label>
                <div className="uber-radio-options" style={{
                  display: 'grid',
                  gridTemplateColumns: `repeat(${Math.min(seatCount, 4)}, 1fr)`,
                  gap: '8px',
                  marginBottom: '20px'
                }}>
                  {seatNumbers.map((seat) => {
                    const riderName = this.getRiderName(seat);
                    return (
                      <label key={'primary-' + seat} className="uber-radio-option" style={{
                        padding: '10px',
                        border: '2px solid',
                        borderColor: uberRide.primaryRider === seat ? '#3498db' : '#ddd',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        textAlign: 'center',
                        transition: 'all 0.2s',
                        backgroundColor: uberRide.primaryRider === seat ? '#e3f2fd' : 'white'
                      }}>
                        <input
                            type="radio"
                            name="primary_rider"
                            checked={uberRide.primaryRider === seat}
                            onChange={() => {
                              const newSeats = uberRide.seats.includes(seat)
                                  ? uberRide.seats
                                  : [...uberRide.seats, seat];
                              this.updateRide({
                                primaryRider: seat,
                                seats: newSeats,
                              });
                            }}
                            style={{ display: 'none' }}
                        />
                        <span style={{ fontWeight: '500', fontSize: '14px' }}>Seat {seat}</span>
                        {riderName && (
                          <div style={{ fontSize: '11px', color: '#666', marginTop: '3px' }}>{riderName}</div>
                        )}
                      </label>
                    );
                  })}
                </div>

                <label className="meta-label" style={{ fontSize: '15px', fontWeight: '600', marginBottom: '12px' }}>
                  Additional Passengers
                </label>
                <div className="uber-radio-options" style={{
                  display: 'grid',
                  gridTemplateColumns: `repeat(${Math.min(seatCount, 4)}, 1fr)`,
                  gap: '8px'
                }}>
                  {seatNumbers.map((seat) => {
                    const disabled = uberRide.primaryRider === seat;
                    const checked = uberRide.seats.includes(seat);
                    const riderName = this.getRiderName(seat);

                    return (
                        <label
                            key={seat}
                            className="uber-radio-option"
                            style={{
                              padding: '10px',
                              border: '2px solid',
                              borderColor: checked ? '#27ae60' : '#ddd',
                              borderRadius: '6px',
                              cursor: disabled ? 'not-allowed' : 'pointer',
                              textAlign: 'center',
                              opacity: disabled ? 0.5 : 1,
                              transition: 'all 0.2s',
                              backgroundColor: checked ? '#e8f5e9' : 'white'
                            }}
                        >
                          <input
                              type="checkbox"
                              disabled={disabled}
                              checked={checked}
                              onChange={(e) => {
                                let newSeats = e.target.checked
                                    ? [...uberRide.seats, seat]
                                    : uberRide.seats.filter((s) => s !== seat);

                                if (uberRide.primaryRider && !newSeats.includes(uberRide.primaryRider)) {
                                  newSeats.push(uberRide.primaryRider);
                                }

                                this.updateRide({ seats: newSeats });
                              }}
                              style={{ display: 'none' }}
                          />
                          <span style={{ fontWeight: '500', fontSize: '14px' }}>Seat {seat}</span>
                          {riderName && (
                            <div style={{ fontSize: '11px', color: '#666', marginTop: '3px' }}>{riderName}</div>
                          )}
                        </label>
                    );
                  })}
                </div>
              </div>

              <div style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '16px',
                padding: '12px 16px',
                backgroundColor: '#fff',
                borderRadius: '8px',
                border: '2px dashed #9b59b6'
              }}>
                <i className="fas fa-route" style={{
                  fontSize: '18px',
                  color: '#9b59b6',
                  marginRight: '12px'
                }} />
                <div>
                  <div style={{ fontWeight: '600', fontSize: '15px', color: '#333' }}>
                    Plan Your Route
                  </div>
                  <div style={{ fontSize: '13px', color: '#666', marginTop: '2px' }}>
                    Set pickup, optional stops, and dropoff locations
                  </div>
                </div>
              </div>

              {this.renderLocationSection('pickup')}

              {(uberRide.stops || []).length > 0 && (
                  <div style={{
                    marginBottom: '12px',
                    padding: '12px',
                    backgroundColor: '#fff3e0',
                    borderRadius: '8px',
                    border: '1px solid #ffb74d'
                  }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: '12px'
                    }}>
                      <i className="fas fa-location-arrow" style={{
                        fontSize: '14px',
                        color: '#f57c00',
                        marginRight: '8px'
                      }} />
                      <span style={{ fontWeight: '600', fontSize: '14px', color: '#e65100' }}>
                    Intermediate Stops ({uberRide.stops.length})
                  </span>
                    </div>
                    <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                      {uberRide.stops.map((stop, index) => (
                          <div key={index} style={{ marginBottom: index < uberRide.stops.length - 1 ? '8px' : '0' }}>
                            {this.renderLocationSection('stop', index)}
                          </div>
                      ))}
                    </div>
                  </div>
              )}

              <div style={{ marginBottom: '12px', textAlign: 'center' }}>
                <button
                    className="button button-outline"
                    onClick={() =>
                        this.updateRide({
                          stops: [...(uberRide.stops || []), { locationType: '', customAddress: '' }],
                        })
                    }
                    style={{
                      width: '100%',
                      borderStyle: 'dashed',
                      borderWidth: '2px',
                      padding: '12px',
                      fontSize: '14px',
                      fontWeight: '500'
                    }}
                >
                  <i className="fas fa-plus-circle" style={{ marginRight: '8px' }} />
                  Add Stop
                </button>
              </div>

              {this.renderLocationSection('dropoff')}
            </div>

            <div
                style={{
                  padding: '16px 24px',
                  borderTop: '2px solid #e0e0e0',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  backgroundColor: '#fafafa',
                }}
            >
              <button
                  className="button button-outline"
                  onClick={onClose}
                  style={{
                    minWidth: '100px',
                    fontSize: '14px',
                    fontWeight: '500'
                  }}
              >
                Cancel
              </button>

              <button
                  className="button"
                  disabled={!isValid || saving}
                  onClick={onSave}
                  style={{
                    minWidth: '140px',
                    fontSize: '14px',
                    fontWeight: '500',
                    backgroundColor: isValid && !saving ? '#9b59b6' : undefined
                  }}
              >
                {saving ? (
                    <>
                      <i className="fa fa-spinner fa-spin" style={{marginRight: '8px'}}></i>
                      Saving...
                    </>
                ) : (
                    <>
                      <i className="fas fa-check-circle" style={{marginRight: '8px'}}></i>
                      Save Ride
                    </>
                )}
              </button>
            </div>
          </div>
        </div>
    );
  }
}